export default __webpack_public_path__ + "static/media/Project3.917e8d3c.png";